<template>
  <div>
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 d-inline-block mb-0">
            {{ $t("profile.profile") }}
          </h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-breadcrumb />
          </nav>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--6">
      <div class="card mb-4">
        <!-- Card header -->
        <div class="card-header">
          <h3 class="mb-0">{{ $t("profile.profile") }}</h3>
        </div>
        <!-- Card body -->
        <div class="card-body">
          <!-- Form groups used in grid -->

          <form>
            <div class="form-group row">
              <label for="profile-name" class="col-md-2 col-form-label form-control-label">{{
                $t("profile.name")
              }}</label>
              <div class="col-md-5">
                <base-input id="profile-name" placeholder="" v-model="params.name"></base-input>
              </div>
            </div>

            <div class="form-group row">
              <label
                for="profile-phone"
                class="col-md-2 col-form-label form-control-label"
                >{{ $t("profile.phone") }} (66xxxxxxxxx)</label
              >
              <div class="col-md-5">
                <base-input id="profile-phone"
                  autocomplete="off"
                  placeholder=""
                  v-model="params.phone"
                />
              </div>
              <div class="col-md-2" v-if="this.currentUser.phone != this.params.phone && this.timerCount == 0 && this.mobileNumberValid">
				<base-button type="primary" @click="handleRequestOTP()"> {{$t("auth.requestotp")}} </base-button>
			  </div>
              <div class="col-md-5" v-if="this.currentUser.phone != this.params.phone && this.timerCount != 0">
				<small>{{ $t("auth.twofa_send_to",[mobileNumber]) }}</small><br>
				<small>{{ $t("auth.requestnewotp",[timerCount]) }}</small>
			  </div>
            </div>

            <div class="form-group row" v-if="params.refCode != ''">
              <label for="profile-otp"
                class="col-md-2 col-form-label form-control-label"
                >{{ $t("auth.otpcode") }} {{ refCodeDisplay }}</label
              >
              <div class="col-md-5">
                <base-input id="profile-otp"
                  autocomplete="off"
                  placeholder=""
                  v-model="params.otpCode"
				  maxlength="6"
                />
              </div>
			</div>


            <div class="form-group row">
              <label for="profile-email"
                class="col-md-2 col-form-label form-control-label"
                >{{ $t("profile.email") }}</label
              >
              <div class="col-md-5">
                <base-input id="profile-email"
                  autocomplete="off"
                  placeholder=""
                  v-model="params.email"
                />
              </div>
            </div>

            <div class="form-group row">
              <div class="offset-md-2 col-md-10">
                <base-button type="primary" @click="handleUpdate()" :disabled="!saveable">{{
                  $t("save")
                }}</base-button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import swal from "sweetalert2";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "CreateNumber",
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn
  },
  computed: {
    ...mapGetters({
      isCorporateAdmin: "Auth/isCorporateAdmin",
      isDtacAdmin: "Auth/isDtacAdmin",
      isReadOnly: "Auth/isReadOnly",
    }),
	refCodeDisplay(){
		return this.params.refCode == "" ? ""  : " : Ref ("+this.params.refCode+")"
	},
	isOTPValid:function(){
		let regOtp = new RegExp("\\d{6}");
		return regOtp.test(this.params.otpCode)
	},
	mobileNumberValid:function(){
		let regMobile = /^66\d{9}$/;
		return regMobile.test(this.params.phone)
	},
	saveable(){
		if (this.params.phone != this.currentUser.phone) {
		  if ( !this.isOTPValid || this.params.refCode == "") {
			return false
		  }

		  if (!this.mobileNumberValid) {
			return false
		  }
		}

		return true
	}

  },
  data() {
    return {
      params: {
        name: "",
        phone: "",
        email: "",
        refCode: "",
        otpCode: "",
        messageId: ""
	  },
	  currentUser:{
		name:"",
		phone:"",
	  },
	  timerCount : 0,
	  mobileNumber:"",
    };
  },
     watch: {
	timerCount: {
		handler(value) {
			if (value > 0) {
				setTimeout(() => {
					this.timerCount--;
				}, 1000);
			}
		},
		immediate: true 
	}

  },
  async mounted() {
	// Get User Profile
	this.params.refCode = ""
	this.params.otpCode = ""
	this.params.messageId = ""
	try{
		let resp = await this.getProfile()
		this.params.name = resp.data.User.Name;
		this.params.phone = resp.data.User.Phone;
		this.params.email = resp.data.User.Email;
		this.currentUser.name = resp.data.User.Name;
		this.currentUser.phone = resp.data.User.Phone;
	} catch {
		 swal.fire({
            title: this.$t("errors.profile.get_profile_failed"),
            text: "",
            icon: "error",
            confirmButtonClass: "btn btn-danger btn-fill",
            buttonsStyling: false
          });
	}
  },

  methods: {
    ...mapActions("Auth", ["setUser", "changeProfile", "changePassword", "getProfile"]),
	handleRequestOTP(){
		let p =  {
			name: this.params.name,
			phone: this.params.phone,
			email: this.params.email,
			refCode: "",
			otpCode: "",
			messageId: ""
		}
		this.timerCount = 30
		this.mobileNumber = ""

		this.changeProfile(p).then(resp => {
			this.params.refCode = resp.data.refCode
			this.params.otpCode = ""
			this.params.messageId = resp.data.messageId
			this.mobileNumber = resp.data.mobilePhone
		})
        .catch(err => {
			  this.params.refCode = ""
				this.params.otpCode = ""
				this.params.messageId = ""
          swal.fire({
            title: this.$t("errors.profile.change_profile_failed"),
            text: this.$t(err.response.data.Msg),
            icon: "error",
            confirmButtonClass: "btn btn-danger btn-fill",
            buttonsStyling: false
          });
        });

	},
    handleUpdate() {

      this.changeProfile(this.params)
        .then(resp => {

			if (this.params.phone != this.currentUser.phone) {
				// phone number change
				if (this.params.refCode == "" && this.params.messageId == ""){
					this.params.refCode = resp.data.refCode
					this.params.otpCode = ""
					this.params.messageId = resp.data.messageId
					this.timerCount = 30
					return 
				} 
			} 
			
			swal.fire({
              title: this.$t("profile.change_profile_success"),
              text: ``,
              icon: "success",
              confirmButtonClass: "btn btn-success btn-fill",
              buttonsStyling: false
            })
            .then(result => {
              // update profile
			  this.params.refCode = ""
				this.params.otpCode = ""
				this.params.messageId = ""
				this.params.name = resp.data.User.Name;
				this.params.phone = resp.data.User.Phone;
				this.params.email = resp.data.User.Email;

              this.setUser(resp.data.User);
              this.$router.push({ name: "agent_number" });
            });
        })
        .catch(err => {
				this.params.otpCode = ""

          swal.fire({
            title: this.TwoFAErrorText(err.response.data.Cause,err.response.data.Msg),
            text: this.TwoFAErrorCode(err.response.data.Cause),
            icon: "error",
            confirmButtonClass: "btn btn-danger btn-fill",
            buttonsStyling: false
          });
        });
    }
  }
};
</script>

<style scoped>
.form-group {
  margin-bottom: 0.2rem !important;
}
</style>
